import { Badge } from '@chakra-ui/react';

import DataTableCard from './DataTableCard';
import ValidationBadge from './ValidationBadge';

interface PrincipalDriverAssignmentCardProps {
  data?: any;
}

const PrincipalDriverAssignmentCard = ({
  data,
}: PrincipalDriverAssignmentCardProps) => {
  const headers = ['Driver', 'Principal on vehicle(s)', 'Remarks', 'Outcome'];

  const rows = data.driverRows.map((row: any) => [
    row.driverName,
    <Badge colorScheme="blue" variant="outline" fontSize="xs">
      {row.principalOnVehicleCount}
    </Badge>,
    row.remarks,
    row.isValid ? (
      <ValidationBadge status="pass" />
    ) : (
      <ValidationBadge status="caution" />
    ),
  ]);

  return (
    <DataTableCard
      description="Check to ensure that, where applicable, a driver is assigned as Principal Operator on at least one or more vehicles."
      headers={headers}
      rows={rows}
    />
  );
};

export default PrincipalDriverAssignmentCard;
